import { createStore } from 'owa-satcheljs';
import type { WindowKey } from 'owa-bizchat-types';

interface CopilotChatTasksHubStore {
    activeWindows: Map<WindowKey, boolean>;
}

export const getStore: () => CopilotChatTasksHubStore = createStore('CopilotChatTasksHubStore', {
    activeWindows: new Map<WindowKey, boolean>(),
});
